module.exports = __webpack_public_path__ + "img/no-data-S6.785bbbf9.png";